import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Row,
    RightComponents,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    MultiSelectBox,
    SearchDateBox,
    SearchBox,
} from '../../components/Form';
import {
    TableData,
    TableHeader,
    TableBody,
    TableRow,
    TableColumn,
} from '../../components/Table';
import {
    MobileInfoBox,
    Title,
    TextView,
    PanelBox,
    Modal,
} from '../../components/Display';
import TaroffTransactionsNew from '../financial/TaroffTransactionsNew';
import { postData } from '../../Api';

export default function TaroffTaroffTransactions(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const handleCreateNewTransaction = () => {
        setModal(
            Modal({
                children: <TaroffTransactionsNew onDismiss={() => setModal(null)} />,
                onDismiss: () => setModal(null),
            })
        );
    };
    const handleCreateNewTransaction2 = () => {
        setModal(
            Modal({
                children: <TaroffTransactionsNew onDismiss={() => setModal(null)} />,
                onDismiss: () => setModal(null),
            })
        );
    };
    const handleSearch = () => {
        applyFilters();
    };
    const [formQShopIdOptions, setFormQShopIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-taroff-transactions/select-data/q-shop-id').then(
            (response) => {
                setFormQShopIdOptions(response.data);
            }
        );
    }, []);
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setFilterQShopId('');
        setFilterQTitle('');
        setFilterQAmountFrom('');
        setFilterQAmountTo('');
        setFilterQInsertTimeFrom('');
        setFilterQInsertTimeTo('');
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        filterQShopId && (newSearchParams['q-shop-id'] = filterQShopId);
        filterQTitle && (newSearchParams['q-title'] = filterQTitle);
        filterQAmountFrom && (newSearchParams['q-amount-from'] = filterQAmountFrom);
        filterQAmountTo && (newSearchParams['q-amount-to'] = filterQAmountTo);
        filterQInsertTimeFrom && (newSearchParams['q-insert-time-from'] = filterQInsertTimeFrom);
        filterQInsertTimeTo && (newSearchParams['q-insert-time-to'] = filterQInsertTimeTo);
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    const [filterQShopId, setFilterQShopId] = useState(allProps['q-shop-id'] || '');
    const [filterQTitle, setFilterQTitle] = useState(allProps['q-title'] || '');
    const [filterQAmountFrom, setFilterQAmountFrom] = useState(allProps['q-amount-from'] || '');
    const [filterQAmountTo, setFilterQAmountTo] = useState(allProps['q-amount-to'] || '');
    const [filterQInsertTimeFrom, setFilterQInsertTimeFrom] = useState(
        allProps['q-insert-time-from'] || ''
    );
    const [filterQInsertTimeTo, setFilterQInsertTimeTo] = useState(
        allProps['q-insert-time-to'] || ''
    );
    useEffect(() => {
        postData('/api/panel/page/taroff-taroff-transactions/table-data', {
            size: tableSize,
            page: tablePage,
            q_shop_id: filterQShopId,
            q_title: filterQTitle,
            q_amount_from: filterQAmountFrom,
            q_amount_to: filterQAmountTo,
            q_insert_time_from: filterQInsertTimeFrom,
            q_insert_time_to: filterQInsertTimeTo,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);
    const handleEditTransaction = (row) => {};
    return (
        <PanelBox>
            <Row>
                <RightComponents>
                    <Title>تراکنش های تعارف</Title>
                    <TextView></TextView>
                    <TextView></TextView>
                </RightComponents>
                <LeftComponents>
                    <Button onClick={handleCreateNewTransaction} color={'secondary'}>
                        ایجاد تراکنش های تعارف
                    </Button>
                </LeftComponents>
            </Row>
            <Row>
                <RightComponents>
                    <Title>تراکنش های تعارف</Title>
                </RightComponents>
                <LeftComponents>
                    <Button onClick={handleCreateNewTransaction2} color={'secondary'}>
                        ایجاد تراکنش های تعارف
                    </Button>
                    <Button onClick={handleSearch} color={'secondary'}>
                        جستجو
                    </Button>
                </LeftComponents>
            </Row>
            <RightComponents wrap={true}>
                <MultiSelectBox
                    label={'فروشگاه'}
                    options={formQShopIdOptions}
                    value={filterQShopId}
                    onChange={setFilterQShopId}
                />
                <SearchBox onEnter={applyFilters}
                    label={'عنوان'}
                    value={filterQTitle}
                    onChange={setFilterQTitle}
                    width={'120px'}
                />
                <SearchBox onEnter={applyFilters}
                    label={'مبلغ از'}
                    value={filterQAmountFrom}
                    onChange={setFilterQAmountFrom}
                    width={'120px'}
                />
                <SearchBox onEnter={applyFilters}
                    label={'مبلغ تا'}
                    value={filterQAmountTo}
                    onChange={setFilterQAmountTo}
                    width={'120px'}
                />
                <SearchDateBox onEnter={applyFilters}
                    label={'زمان درج از'}
                    value={filterQInsertTimeFrom}
                    onChange={setFilterQInsertTimeFrom}
                    width={'100px'}
                />
                <SearchDateBox onEnter={applyFilters}
                    label={'زمان درج تا'}
                    value={filterQInsertTimeTo}
                    onChange={setFilterQInsertTimeTo}
                    width={'100px'}
                />
                <Button rightIcon={'far fa-search'} onClick={applyFilters}>
                    جستجو
                </Button>
                <Button rightIcon={'far fa-trash'} onClick={clearFilters}>
                    پاک کردن
                </Button>
            </RightComponents>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>شناسه</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>مبلغ</TableColumn>
                        <TableColumn mobile={false}>زمان ایجاد</TableColumn>
                        <TableColumn mobile={false}></TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_id}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_shop_id_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true}>{row.text_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_amount}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'persian-date-normal'}>
                                    {row.text_inserttime}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <Button
                                    onClick={() => handleEditTransaction(row)}
                                    rightIcon={'far fa-edit'}
                                    tooltip={'ویرایش'}
                                ></Button>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
